module.exports = __webpack_public_path__ + "static/media/botafogo-svg.bba4d203.svg";